import handleCart from './handleCart'
import { combineReducers } from "redux";
import handleFavorites from './handleFavorites';
const rootReducers = combineReducers({
    handleCart,
    handleFavorites
})
export default rootReducers